import { errorAction, successfulAction } from '@shared/actions';
import { STATUS_CODE } from '@shared/constants';
import { storageCache } from '@services/cache';
import getReliableAgeValidation from '@services/cart/getReliableAgeValidation';
import getUserId from '@core/reducers/user/selectors/getUserId';
import { USER_VALIDATE_RELIABLE_DNI as type } from '@core/reducers/cart/actionTypes';
import { USER_VALIDATION, DNI_USER_VALID_STORAGE } from '../constants';

const errorCode = STATUS_CODE.INTERNAL_ERROR;

const fetchReliableAgeValidation = (identityCard, birthday) => async (
  dispatch,
  getState,
  axios,
) => {
  try {
    dispatch({ type });
    const state = getState();
    const userId = getUserId(state);
    if (birthday && identityCard) {
      const { data } = await getReliableAgeValidation({
        axios,
        identityCard,
        birthday,
        userId,
      });

      if (data) {
        if (data.status === USER_VALIDATION.VALID) {
          // remove when have an user endpoint
          storageCache.set(DNI_USER_VALID_STORAGE, true);
        }

        dispatch(
          successfulAction({
            type,
          }),
        );
        return data.status;
      }
      return false;
    }
  } catch (error) {
    dispatch(
      errorAction({
        type,
        error,
        errorCode,
      }),
    );
  }
  return false;
};

export default fetchReliableAgeValidation;
